import { Client } from '@spree/core-api-v2-sdk'
import type { IClientConfig } from '@spree/core-api-v2-sdk'
import {
  Addresses,
  Adjustments,
  Classifications,
  Countries,
  Pages,
  Sections,
  Digitals,
  Links,
  Items,
  Menus,
  MenuItems,
  OptionTypes,
  OptionValues,
  Orders,
  Payments,
  PaymentMethods,
  Products,
  Promotions,
  PromotionActions,
  PromotionCategories,
  PromotionRules,
  Roles,
  Shipments,
  ShippingCategories,
  ShippingMethods,
  States,
  StockItems,
  StockLocations,
  StoreCreditCategories,
  StoreCreditTypes,
  StoreCredits,
  TaxCategories,
  TaxRates,
  Taxons,
  Taxonomies,
  Users,
  Variants,
  WebhookEvents,
  WebhookSubscribers,
  Wishlists,
  WishedItems,
  Zones
} from './endpoints'

const endpoints = {
  addresses: Addresses,
  adjustments: Adjustments,
  classifications: Classifications,
  countries: Countries,
  pages: Pages,
  sections: Sections,
  digitals: Digitals,
  links: Links,
  items: Items,
  menus: Menus,
  menuItems: MenuItems,
  optionTypes: OptionTypes,
  optionValues: OptionValues,
  orders: Orders,
  payments: Payments,
  paymentMethods: PaymentMethods,
  products: Products,
  promotions: Promotions,
  promotionActions: PromotionActions,
  promotionCategories: PromotionCategories,
  promotionRules: PromotionRules,
  roles: Roles,
  shipments: Shipments,
  shippingCategories: ShippingCategories,
  shippingMethods: ShippingMethods,
  states: States,
  stockItems: StockItems,
  stockLocations: StockLocations,
  storeCreditCategories: StoreCreditCategories,
  storeCreditTypes: StoreCreditTypes,
  storeCredits: StoreCredits,
  taxCategories: TaxCategories,
  taxRates: TaxRates,
  taxons: Taxons,
  taxonomies: Taxonomies,
  users: Users,
  variants: Variants,
  webhookEvents: WebhookEvents,
  webhookSubscribers: WebhookSubscribers,
  wishlists: Wishlists,
  wishedItems: WishedItems,
  zones: Zones
}

const makeClient = (config: IClientConfig): Client => new Client(config, endpoints)

export default makeClient
